/**
 * Configuracion y endpoints de la API del SSO.
 */

import { env } from './env';

export const apiConfig = {
  baseURL: env.api.baseURL,
  timeout: env.api.timeout,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

export const API_ENDPOINTS = {
  applications: {
    base: '/applications',
    byId: (id: string) => `/applications/${id}`,
    activate: (id: string) => `/applications/${id}/activate`,
    deactivate: (id: string) => `/applications/${id}/deactivate`,
  },
  roles: {
    base: '/roles',
    byId: (id: string) => `/roles/${id}`,
    activate: (id: string) => `/roles/${id}/activate`,
    deactivate: (id: string) => `/roles/${id}/deactivate`,
  },
  users: {
    base: '/users',
    invite: '/users/invite',
    suspend: (id: string) => `/users/${id}/suspend`,
    reactivate: (id: string) => `/users/${id}/reactivate`,
    resetPassword: (id: string) => `/users/${id}/reset-password`,
  },
  access: {
    me: '/me',
    myRoles: '/me/roles',
    userRoles: (userId: string) => `/users/${userId}/roles`,
    userRole: (userId: string, roleId: string) => `/users/${userId}/roles/${roleId}`,
  },
} as const;
